import React from "react";
import { PageHero, CTABlock, SectionLabel } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";

const services = [
  { title: "Grovrengöring och behandling", text: "Djuprengöring för slitna ytor – fräschar upp och förbereder för behandling." },
  { title: "Lättskurning och polering", text: "Underhåll för golv som behöver återfå sin lyster." },
  { title: "Mattvätt", text: "Professionell tvätt av heltäckningsmattor och lösa mattor." },
  { title: "Möbeltvätt", text: "Skonsam och effektiv rengöring av soffor och stolar i lokaler." },
  { title: "Golvslipning", text: "För trä och parkett – fräschar upp och förlänger livslängden." },
  { title: "Golvläggning", text: "Vi kan även hjälpa till med nya golv när det är dags." },
];

export default function Golvvard() {
  return (
    <>
      <PageHero
        eyebrow="Specialisttjänst"
        title="Golvvård som skyddar och fräschar upp"
        intro="Har golven i era lokaler tappat lystern, blivit svårstädade eller börjat se slitna ut? Rena Tjänster hjälper till med golvvård som skyddar, fräschar upp och förlänger livslängden på era golv."
        image={ASSETS.floorCare}
        imageAlt="Golvvård och polering av Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="golv-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <section className="py-20 lg:py-28" data-testid="golv-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-12">
            <SectionLabel className="mb-4">Olika golvtyper</SectionLabel>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-4">
              Rengöring, vaxning, polish och behandling
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Vi arbetar med rengöring, vaxning, polish och behandling av olika golvtyper, till exempel
              plast, parkett och klinker – för kontor, butiker, fastigheter och andra verksamheter.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100 hover:border-[#F59E0B]/40 hover:shadow-md transition-all" data-testid={`golv-service-${i}`}>
                <div className="w-10 h-10 rounded-lg bg-[#F59E0B]/15 inline-flex items-center justify-center text-[#1E3A6F] font-display font-semibold mb-4">{i + 1}</div>
                <h3 className="font-display text-lg font-semibold text-slate-900 mb-2">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABlock
        title="Vill ni veta vilken golvvård som passar bäst?"
        description="Skicka en offertförfrågan så återkommer vi med rekommendationer för just era golv."
      />
    </>
  );
}
